module.exports = __webpack_public_path__ + "static/media/uncheck.89ff154e.png";